var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuperadminDashboardItemTotalPaymentsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.599,
    height: 46.598,
    viewBox: "0 0 46.599 46.598",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Discount",
    transform: "translate(0.75 0.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_1",
    "data-name": "Stroke 1",
    d: "M4.817,10.146a5.331,5.331,0,0,1,5.329-5.331h2.425a5.33,5.33,0,0,0,3.754-1.548l1.694-1.7a5.33,5.33,0,0,1,7.537-.019l.021.019,1.7,1.7a5.322,5.322,0,0,0,3.754,1.548h2.423a5.332,5.332,0,0,1,5.331,5.331v2.42a5.327,5.327,0,0,0,1.548,3.757l1.7,1.7a5.33,5.33,0,0,1,.021,7.537l-.021.021-1.7,1.7a5.316,5.316,0,0,0-1.548,3.752v2.425a5.33,5.33,0,0,1-5.331,5.329H31.029a5.324,5.324,0,0,0-3.754,1.551l-1.7,1.694a5.328,5.328,0,0,1-7.537.021l-.021-.021-1.694-1.694a5.332,5.332,0,0,0-3.754-1.551H10.146a5.329,5.329,0,0,1-5.329-5.329V31.027a5.319,5.319,0,0,0-1.551-3.752l-1.694-1.7a5.328,5.328,0,0,1-.021-7.537l.021-.021,1.694-1.7a5.33,5.33,0,0,0,1.551-3.757v-2.42",
    transform: "translate(0.75 0.751)",
    fill: "none",
    stroke: "#199b8b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_3",
    "data-name": "Stroke 3",
    d: "M0,12.113,12.113,0",
    transform: "translate(16.493 16.491)",
    fill: "none",
    stroke: "#199b8b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_5",
    "data-name": "Fill 5",
    d: "M1.768,3.511A1.766,1.766,0,0,1,.518,2.993,1.936,1.936,0,0,1,.141,2.4,1.574,1.574,0,0,1,0,1.744a1.691,1.691,0,0,1,.141-.683A1.829,1.829,0,0,1,.518.495a1.824,1.824,0,0,1,2.5,0,1.9,1.9,0,0,1,.4.566,2.19,2.19,0,0,1,.118.683,2.033,2.033,0,0,1-.118.66,2.007,2.007,0,0,1-.4.589,1.766,1.766,0,0,1-1.249.518",
    transform: "translate(26.831 26.867)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_7",
    "data-name": "Fill 7",
    d: "M1.768,3.513a1.584,1.584,0,0,1-.66-.144,1.929,1.929,0,0,1-.589-.375,2.27,2.27,0,0,1-.377-.589A1.589,1.589,0,0,1,0,1.746a1.682,1.682,0,0,1,.141-.683A1.589,1.589,0,0,1,.518.5a1.819,1.819,0,0,1,2.5,0,1.762,1.762,0,0,1,.518,1.249,1.57,1.57,0,0,1-.118.66,2.372,2.372,0,0,1-.4.589,1.822,1.822,0,0,1-.566.375,1.693,1.693,0,0,1-.683.144",
    transform: "translate(14.717 14.753)",
    fill: "#199b8b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperadminDashboardItemTotalPaymentsIcon);
export default __webpack_public_path__ + "static/media/superadmin-dashboard-item-total-payments-icon.df5fcd45d082a5d3c491d8833c0827aa.svg";
export { ForwardRef as ReactComponent };